import { IServicePackagePeriod } from '../../../repositories/billing-tariffs/entities/PublishTerms/ServicePackagePeriod';
import { getPackageId } from './getPackageId';

export function getSelectedPackageId(packages: IServicePackagePeriod[]): string | null {
  const paidPackage = packages.find(({ isPaid }) => isPaid);
  const defaultPackage = packages.find(({ isDefault }) => isDefault);
  const firstPackage = packages[0];

  if (paidPackage) {
    return getPackageId(paidPackage);
  }

  if (defaultPackage) {
    return getPackageId(defaultPackage);
  }

  if (firstPackage) {
    return getPackageId(firstPackage);
  }

  return null;
}
